import { useInView } from 'react-hook-inview';

import { isPrerenderIoBot, isSearchEngineBot } from 'src/utils/bots';

export type ViewportVisibility = {
  hasBeenVisible: boolean;
  isVisible: boolean;
  ref: ReturnType<typeof useInView>[0];
};

export type ViewportVisibilityOptions = {
  disableBotDetection?: boolean;
  rootMargin?: string;
  threshold?: number;
};

export default function useViewportVisibility({
  disableBotDetection = false,
  rootMargin,
  threshold = 0,
}: ViewportVisibilityOptions = {}): ViewportVisibility {
  const [ref, isVisibleConst] = useInView({ unobserveOnEnter: true, rootMargin, threshold });
  let isVisible = isVisibleConst;

  // Preserve the legacy browser behavior unless an SSR-sensitive caller needs the server and first
  // client render to agree. Those callers activate from IntersectionObserver for every user agent.
  if (!disableBotDetection && (isPrerenderIoBot() || isSearchEngineBot())) {
    isVisible = true;
  }

  // this is a legacy hook, so we need to keep it for now.
  const hasBeenVisible = isVisible;

  return { hasBeenVisible, isVisible, ref };
}
